/* TRATHAM — PLP: seletor de densidade da grade (ícones na linha de ordenação; preferência salva no navegador) */
if (!customElements.get('tr-density')) {
  customElements.define('tr-density', class extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 768px)');
      this.template = this.querySelector('[data-density-template]');
      this.apply(this.saved() || this.fallback());
      this.mount();
      // Filtros/ordenação re-renderizam a grade via AJAX: reinsere o seletor
      document.addEventListener('facets:updated', () => requestAnimationFrame(() => this.mount()));
      new MutationObserver(() => { if (!this.querySelector('.tr-plp__density')) this.mount(); })
        .observe(this, { childList: true, subtree: true });
      this.mq.addEventListener('change', () => this.apply(this.saved() || this.fallback()));
    }
    key() { return 'tr-density-' + (this.mq.matches ? 'desktop' : 'mobile'); }
    fallback() { return this.mq.matches ? this.dataset.densityDesktop : this.dataset.densityMobile; }
    saved() { try { return localStorage.getItem(this.key()); } catch (e) { return null; } }
    mount() {
      if (!this.template || this.querySelector('.tr-plp__density')) return;
      const target = this.querySelector('.thb-filter-sort-count') || this.querySelector('.facets--bar');
      if (!target) return;
      const node = this.template.content.firstElementChild.cloneNode(true);
      node.querySelectorAll('[data-density]').forEach((btn) => btn.addEventListener('click', () => {
        this.apply(btn.dataset.density);
        try { localStorage.setItem(this.key(), btn.dataset.density); } catch (e) {}
      }));
      target.prepend(node);
      this.apply(this.dataset.density);
    }
    apply(value) {
      this.dataset.density = value;
      const group = this.mq.matches ? '.tr-plp__density-btn--desktop' : '.tr-plp__density-btn--mobile';
      this.querySelectorAll(group).forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.density === String(value))));
    }
  });
}

/* TRATHAM — abas de categoria: filtram a grade na própria página (todas as peças já estão nela) */
(() => {
  let atual = new URL(location.href).searchParams.get('categoria') || '';
  const contador = () => document.querySelector('#ProductCount .facets__label');
  function aplicar() {
    const grid = document.getElementById('product-grid');
    const abas = [...document.querySelectorAll('[data-plp-tabs] [data-plp-cat]')];
    if (!grid || !abas.length) return;
    if (!abas.some((a) => a.dataset.plpCat === atual)) atual = '';
    let visiveis = 0;
    grid.querySelectorAll(':scope > .tr-plp__item').forEach((item) => {
      const mostra = !atual || item.dataset.category === atual;
      item.hidden = !mostra;
      if (mostra) visiveis += 1;
    });
    abas.forEach((a) => a.setAttribute('aria-pressed', String(a.dataset.plpCat === atual)));
    const url = new URL(location.href);
    if ((url.searchParams.get('categoria') || '') !== atual) {
      if (atual) url.searchParams.set('categoria', atual); else url.searchParams.delete('categoria');
      history.replaceState(history.state, '', url);
    }
    const c = contador();
    if (c) {
      if (!c.dataset.original) c.dataset.original = c.textContent.trim();
      c.textContent = atual ? c.dataset.original.replace(/\d+/, visiveis) : c.dataset.original;
    }
  }
  document.addEventListener('click', (e) => {
    const aba = e.target.closest('[data-plp-cat]');
    if (!aba) return;
    atual = aba.dataset.plpCat;
    aplicar();
  });
  /* filtros/ordenação re-renderizam a grade por AJAX: reaplica a aba escolhida */
  document.addEventListener('facets:updated', () => requestAnimationFrame(aplicar));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aplicar); else aplicar();
})();
